class WishlistGrid extends HTMLElement {
  constructor() {
    super();
    this.key = 'wishlist-handles';
    this.wishlistGrid = this.querySelector('[data-wishlist-items-grid]');
  }

  connectedCallback() {
    window.addEventListener('load', this.fetchProducts.bind(this));
  }

  hasItems() {
    return localStorage.getItem(this.key) ? true : false;
  }

  fetchProducts() {
    if (!this.hasItems()) return this.reveal();
    const handles = localStorage.getItem(this.key).split(',');
    const fetchProductsByHandle = handles.map(
      (handle) =>
        new Promise((resolve, reject) => {
          fetch(
            `${window.Shopify.routes.root}products/${handle}?view=wishlist-item`
          )
            .then((response) => response.text())
            .then((html) => resolve(html))
            .catch((error) => reject(error));
        })
    );
    Promise.all(fetchProductsByHandle).then((html) => {
      new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelectorAll('wishlist-item')
        .forEach((product) => {
          const productHtmlWrapper = document.createElement('DIV');

          productHtmlWrapper.classList.add(
            'grid__item',
            'grid__col--4',
            'grid__col--lg-3'
          );
          productHtmlWrapper.appendChild(product);
          this.wishlistGrid.append(productHtmlWrapper);
          this.reveal();
        });
    });
  }

  reveal() {
    this.classList.remove('is-loading');
    this.classList.toggle('is-empty', !this.hasItems());
  }
}

customElements.define('wishlist-grid', WishlistGrid);
